import { IUser, INamespace } from '@/types';
import { TAccessLevel } from '@/types';

export class NamespaceAuthorization {
  private user?: IUser;
  private namespace?: INamespace;
  private userRole: TAccessLevel;
  private awaitingUserVerification: boolean;

  private getUserRole(): TAccessLevel {
    return this.namespace?.access_level || 'none';
  }

  constructor({
    user,
    namespace,
    awaitingUserVerification = true,
  }: {
    user?: IUser;
    namespace?: INamespace;
    awaitingUserVerification?: boolean;
  }) {
    this.user = user;
    this.namespace = namespace;
    this.userRole = this.getUserRole();
    this.awaitingUserVerification = awaitingUserVerification;
  }

  private isNamespaceOwner(): boolean {
    if (!this.user) {
      return false;
    }
    const isOrgNamespaceOwner = this.namespace?.object.created_by?.id === this.user?.id;
    const isUserNamespaceOwner = this.namespace?.object.id === this.user?.id;
    return isOrgNamespaceOwner || isUserNamespaceOwner;
  }

  private isNamespaceAdmin(): boolean {
    return this.userRole === 'admin';
  }

  private isNamespaceEditor(): boolean {
    return ['admin', 'editor'].includes(this.userRole);
  }

  canEdit(): boolean {
    return !this.awaitingUserVerification && this.isNamespaceEditor();
  }

  canViewSettings(): boolean {
    return !!this.isNamespaceEditor();
  }

  canManage(): boolean {
    return !this.awaitingUserVerification && this.isNamespaceAdmin();
  }

  isOwner(): boolean {
    return !!this.isNamespaceOwner();
  }
}
